import { FromViewState } from 'owa-mail-compose-store';
import { mutatorAction } from 'satcheljs';

export default mutatorAction('setIsFromValid', function setIsFromValid(
    fromViewState: FromViewState,
    isFromValid: boolean
) {
    fromViewState.isFromValid = isFromValid;
});
